import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT, waLink } from "@/config/brand";

export const CtaBand = ({ variant = "dark", title = "Planning a Move in London?", subtitle }) => (
    <section
        className={`${
            variant === "dark" ? "bg-[#03283D] text-white" : "bg-[#F3F7F9] text-[#17252D]"
        }`}
    >
        <div className="container-ys section text-center">
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h2>
            {subtitle && (
                <p className={`mt-3 mx-auto max-w-2xl text-base md:text-lg ${variant === "dark" ? "text-white/80" : "text-[#17252D]/75"}`}>
                    {subtitle}
                </p>
            )}
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link to="/request-a-quote">
                    <Button data-testid="cta-band-quote" className={`h-11 px-6 font-semibold ${variant === "dark" ? "bg-white hover:bg-white/90 text-[#001B3D]" : "bg-[#001B3D] hover:bg-[#001B3D]/90 text-white"}`}>
                        <FileText className="h-4 w-4 mr-2" /> Get a Free Quote
                    </Button>
                </Link>
                <a href={waLink()} target="_blank" rel="noreferrer">
                    <Button data-testid="cta-band-whatsapp" className="h-11 px-6 bg-[#25D366] hover:bg-[#20b955] text-white font-semibold">
                        <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp Us
                    </Button>
                </a>
                <a href={CONTACT.phoneHref}>
                    <Button data-testid="cta-band-call" variant="ghost" className={`h-11 px-6 ${variant === "dark" ? "text-white hover:bg-white/10" : "text-[#17252D]"}`}>
                        <Phone className="h-4 w-4 mr-2" /> Call Now
                    </Button>
                </a>
            </div>
        </div>
    </section>
);
